"use client";
import * as React from "react";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@components/ui/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Input } from "@components/ui/input";
import { Button } from "@components/ui/button";
import { Checkbox } from "@components/ui/checkbox";
import { toast } from "sonner";

import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { AppDispatch } from "@app/store";
import { changeRecoveryPassword, checkCodePassword, login, recoveryPassword } from "@features/auth/authSlice";
import { useEffect } from "react";
import { ApiError } from "@/types/api";
import { CircularProgress } from "@mui/material";
import { truncate } from "lodash";

const formSchema = z.object({
  email: z.string().email("Email inválido!"),
  code: z.string().nullable(),
  password: z.string().nullable(),
  password_confirm: z.string().nullable(),
});

export const LoginForm: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [sended_code, setSendedCode] = React.useState(0);


  useEffect(() => {
    const wasRedirected = location.state?.from?.pathname;
    if (wasRedirected) {
      //TODO: setError
    }
  }, [location]);

  const [showPassword, setShowPassword] = React.useState(false);

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: "",
      code: '',
      password: '',
      password_confirm: '',
    },
    mode: "onChange",
    criteriaMode: "all",
    shouldFocusError: true,
  });


  const handleSubmit = async (values: z.infer<typeof formSchema>, sended_code_force: any = undefined) => {
    // Handle login logic here
    console.log(values);
    setLoading(true);
    try {
      if (sended_code == 0 || sended_code_force == 0) {
        const resultAction = await dispatch(
          recoveryPassword({
            email: values.email,
          })
        );

        if (recoveryPassword.fulfilled.match(resultAction)) {
          // Redirecionar para a página anterior ou dashboard
          const from = location.state?.from?.pathname || "/dashboard";
          toast.success("Uma mensagem com o link de recuperação foi enviada para seu e-mail");
          setSendedCode(1)

          // navigate(from, { replace: true });
        } else if (recoveryPassword.rejected.match(resultAction)) {
          // Capturar a mensagem de erro do backend
          const payload = resultAction.payload as ApiError;
          console.log(payload);
          toast.error(payload.message);
          form.setError('email', { type: '400', message: 'E-mail não encontrado.' });


          //TODO: setError(payload);
        }
      }
      else if (sended_code == 1) {
        const resultAction = await dispatch(
          checkCodePassword({
            email: values.email,
            code: values.code ?? '',
          })
        );

        if (checkCodePassword.fulfilled.match(resultAction)) {
          // Redirecionar para a página anterior ou dashboard
          const from = location.state?.from?.pathname || "/dashboard";
          toast.success("Altere sua senha");
          setSendedCode(2)

          // navigate(from, { replace: true });
        } else if (checkCodePassword.rejected.match(resultAction)) {
          // Capturar a mensagem de erro do backend
          const payload = resultAction.payload as ApiError;
          console.log(payload);
          toast.error(payload.message);
          form.setError('code', { type: '400', message: 'Código não encontrado.' });


          //TODO: setError(payload);
        }
      }
      else if (sended_code == 2) {
        const resultAction = await dispatch(
          changeRecoveryPassword({
            email: values.email,
            code: values.code ?? '',
            password: values.password ?? '',
            password_confirm: values.password_confirm ?? '',
          })
        );

        if (checkCodePassword.fulfilled.match(resultAction)) {
          // Redirecionar para a página anterior ou dashboard
          const from = location.state?.from?.pathname || "/login";
          toast.success("Faça login com sua nova senha!");
          setSendedCode(2)

          navigate(from, { replace: true });
        } else if (checkCodePassword.rejected.match(resultAction)) {
          // Capturar a mensagem de erro do backend
          const payload = resultAction.payload as ApiError;
          console.log(payload);
          toast.error(payload.message);
          form.setError('code', { type: '400', message: 'Código não encontrado.' });


          //TODO: setError(payload);
        }
      }
    } catch (err) {
      form.setError('email', { type: '400', message: 'E-mail não encontrado.' });
    }
    setLoading(false);

    // form.reset();
  };

  const handleRegister = () => {
    // Handle register logic here, remove toast.info
    // toast.info("Navegar para tela de registro");
    navigate('/login', { replace: true });

  };

  const handleForgotPassword = () => {
    // Handle forgot password logic here, remove toast.info
    toast.info("Navegar para tela de esqueci minha senha");
  };

  return (
    <section className="flex flex-col justify-center items-center self-stretch my-auto min-w-60 w-lg">
      {/* FORM */}
      <div className="">
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(handleSubmit)}
            className="flex flex-col w-full"
          >
            <h2 className="self-center text-2xl font-semibold text-center text-foreground">
              Recuperar senha
            </h2>
            <div className="mt-10 max-w-full w-[403px]">
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => {
                  let state = form.getFieldState('email').error;
                  console.log('state', state, state != undefined ? 'red' : '#e5e7eb')
                  return (
                    <FormItem>
                      {/* <FormLabel>Email</FormLabel> */}
                      <label className="text-sm font-semibold text-gray-700">
                        E-mail {<b style={{ color: 'red' }}>*</b>}
                      </label>
                      <FormControl>
                        <Input
                          placeholder="Email"
                          style={{ borderColor: '#e5e7eb' }}
                          disabled={sended_code != 0}
                          {...field}
                          className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 mt-1.5 w-full rounded-xl basis-0 bg-zinc-50 min-h-12 placeholder:text-muted-foreground"
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )
                }}
              />
            </div>


            {sended_code == 1 && <div className="mt-5 max-w-full w-[403px]"><FormField
              control={form.control}
              name="code"
              render={({ field }) => {
                let state = form.getFieldState('code').error;
                console.log('state', state, state != undefined ? 'red' : '#e5e7eb')
                return (
                  <FormItem>
                    {/* <FormLabel>Código enviado por E-mail</FormLabel> */}
                    <label className="text-sm font-semibold text-gray-700">
                      Código enviado por E-mail {<b style={{ color: 'red' }}>*</b>}
                    </label>
                    <FormControl>
                      <Input
                        placeholder="Código enviado por E-mail"
                        style={{ borderColor: '#e5e7eb' }}

                        {...field}
                        className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 mt-1.5 w-full rounded-xl basis-0 bg-zinc-50 min-h-12 placeholder:text-muted-foreground"
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )
              }}
            /> </div>}

            {sended_code == 2 && <>
            <div className="mt-5 max-w-full w-[403px]">
              <FormField
                control={form.control}
                name="password"
                render={({ field }) => {
                  console.log(field)

                  let state = form.getFieldState('password').error;
                  console.log(state)
                  return (<FormItem>
                    {/* <FormLabel>Senha</FormLabel> */}
                    <label className="text-sm font-semibold text-gray-700">
                      Senha {<b style={{ color: 'red' }}>*</b>}
                    </label>
                    <FormControl>
                      <div className="relative">
                        <Input
                          placeholder="Senha"
                          type={showPassword ? "text" : "password"}
                          style={{ borderColor: '#e5e7eb' }}
                          {...field}
                          className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 mt-1.5 w-full rounded-xl basis-0 bg-zinc-50 min-h-12"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            console.log("clicou");
                            setShowPassword(!showPassword);
                          }}
                          className="absolute cursor-pointer z-10 right-3 top-11 -translate-y-1/2 flex justify-center items-center self-stretch my-auto w-6"
                        >
                          <div className="flex overflow-hidden flex-col justify-center items-center self-stretch my-auto w-6 max-w-6 min-h-6 min-w-6">
                            <img
                              src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/8f5443055f0872d6f7925186506d4a633f96b658?placeholderIfAbsent=true"
                              alt={
                                showPassword
                                  ? "Hide password"
                                  : "Show password"
                              }
                              className="object-contain w-full aspect-[1.33] fill-slate-500"
                            />
                          </div>
                        </button>
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>)
                }
                }
              />
              </div>
              <div className="mt-5 max-w-full w-[403px]">
              <FormField
                control={form.control}
                name="password_confirm"
                render={({ field }) => {
                  console.log(field)

                  let state = form.getFieldState('password_confirm').error;
                  console.log(state)
                  return (<FormItem>
                    {/* <FormLabel>Senha</FormLabel> */}
                    <label className="text-sm font-semibold text-gray-700">
                      Confirmar Senha {<b style={{ color: 'red' }}>*</b>}
                    </label>
                    <FormControl>
                      <div className="relative">
                        <Input
                          placeholder="Senha"
                          type={showPassword ? "text" : "password"}
                          style={{ borderColor: '#e5e7eb' }}
                          {...field}
                          className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 mt-1.5 w-full rounded-xl basis-0 bg-zinc-50 min-h-12"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            console.log("clicou");
                            setShowPassword(!showPassword);
                          }}
                          className="absolute cursor-pointer z-10 right-3 top-11 -translate-y-1/2 flex justify-center items-center self-stretch my-auto w-6"
                        >
                          <div className="flex overflow-hidden flex-col justify-center items-center self-stretch my-auto w-6 max-w-6 min-h-6 min-w-6">
                            <img
                              src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/8f5443055f0872d6f7925186506d4a633f96b658?placeholderIfAbsent=true"
                              alt={
                                showPassword
                                  ? "Hide password"
                                  : "Show password"
                              }
                              className="object-contain w-full aspect-[1.33] fill-slate-500"
                            />
                          </div>
                        </button>
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>)
                }
                }
              />
              </div>
            </>}




            {/* <div className="flex items-center mt-8 w-full min-h-5">
              <div className="flex gap-3.5 items-center justify-between self-stretch px-0.5 my-auto min-w-60 w-[404px]">
               
              </div>
            </div> */}
          </form>
        </Form>
      </div>

      {/* BUTTON ACTIONS */}
      <div className="flex flex-col justify-center items-center mt-10 w-full">
        {loading ? <CircularProgress /> : <Button
          type="button"
          onClick={(e) => {
            // form.handleSubmit(handleSubmit)
            handleSubmit(form.getValues())
          }}
          className="items-center w-[170px] max-md:px-5"
          style={{ background: '#3975C9' }}
        >
          <span className="text-base font-bold basis-0 pr-2" style={{ color: 'white' }}>{sended_code == 0 ? 'Recuperar' : (sended_code == 1 ? 'Enviar' : 'Salvar')}</span>
          <div className="flex flex-col justify-center items-center self-stretch my-auto w-4">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/8b0ee723288ad50ae8b825c5736ee7678ef9079e?placeholderIfAbsent=true"
              alt="Enter icon"
              className="object-contain w-full aspect-[1.33] fill-zinc-50"
            />
          </div>
        </Button>}
        {sended_code == 1 && <Button
          onClick={() => {
            setSendedCode(0)
            handleSubmit(form.getValues(), 0);
          }}
          variant="ghost"
          style={{ color: '#3975C9' }}
          className="mt-6 text-sm font-semibold text-center flex overflow-hidden gap-3.5 justify-center items-center px-11 py-3.5  text-primary"
        >
          Não recebeu o e-mail? Clique para enviar novamente
        </Button>}
        {<Button
          onClick={handleRegister}
          variant="ghost"
          style={{ color: '#3975C9' }}
          className="mt-6 text-sm font-semibold text-center flex overflow-hidden gap-3.5 justify-center items-center px-11 py-3.5  text-primary"
        >
          Lembrou a senha? Faça Login
        </Button>}


      </div>
    </section>
  );
};
